import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    saveWikiNote: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-notes/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiNotes'],
    }),
    updateWikiNote: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-notes/${arg.id}/`,
          method: 'PATCH',
          body: arg.frm,
        };
      },
      invalidatesTags: ['wikiNotes'],
    }),
    getWikiNotes: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-notes/?`,
          method: 'GET',
          params: arg,
        };
      },
      providesTags: ['wikiNotes'],
    }),
    deleteWikiNote: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-notes/${arg.id}/`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['wikiNotes'],
    }),
  }),
});

export const { useSaveWikiNoteMutation, useUpdateWikiNoteMutation, useGetWikiNotesQuery, useDeleteWikiNoteMutation } = api;
